var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"px-1"},[(_vm.egress_profile_matter_id)?[_c('MatterProgram',{attrs:{"egress_profile_matter_id":_vm.egress_profile_matter_id,"allows_crud":_vm.allows_crud}})]:[_vm._v(" Ha ocurrido un error... ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }